'use client';

import posthog from 'posthog-js';
import { resolvePostHogDeploymentProperties } from '../deployment-environment';
import {
  createPostHogExceptionBeforeSend,
  POSTHOG_BROWSER_ERROR_CONFIG,
} from './posthog-browser-error-policy';

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogHost =
  process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';
const posthogUiHost = posthogHost.replace('.i.posthog.com', '.posthog.com');

export const posthogDeploymentProperties = resolvePostHogDeploymentProperties({
  convexUrl: process.env.NEXT_PUBLIC_CONVEX_URL,
  hostname:
    typeof window === 'undefined' ? undefined : window.location.hostname,
  imaiEnvironment: process.env.NEXT_PUBLIC_IMAI_ENV,
  vercelGitCommitRef: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF,
  vercelGitCommitSha: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  vercelTargetEnvironment:
    process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV ||
    process.env.NEXT_PUBLIC_VERCEL_ENV,
});

let isInitialized = false;
let missingKeyWarningEmitted = false;

export const registerPostHogDeploymentProperties = (): void => {
  posthog.register(posthogDeploymentProperties);
};

export const ensurePostHogBrowserInitialized = (): boolean => {
  if (isInitialized) return true;
  if (typeof window === 'undefined') return false;

  const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '::1';
  const enableLocalAnalytics =
    process.env.NEXT_PUBLIC_ENABLE_LOCAL_ANALYTICS === 'true';
  const shouldInitialize =
    typeof posthogKey === 'string' &&
    posthogKey.length > 0 &&
    (!isLocalhost || enableLocalAnalytics);

  if (!shouldInitialize) {
    if (!isLocalhost && !posthogKey && !missingKeyWarningEmitted) {
      console.warn(
        '[PostHog] NEXT_PUBLIC_POSTHOG_KEY is not set; PostHog analytics are disabled.'
      );
      missingKeyWarningEmitted = true;
    }
    return false;
  }

  posthog.init(posthogKey, {
    api_host: '/ph-ingest',
    ui_host: posthogUiHost,
    defaults: '2025-05-24',
    person_profiles: 'identified_only',
    capture_pageview: 'history_change',
    capture_pageleave: true,
    ...POSTHOG_BROWSER_ERROR_CONFIG,
    before_send: createPostHogExceptionBeforeSend(),
  });
  registerPostHogDeploymentProperties();
  isInitialized = true;
  return true;
};

export { posthog };
